// Modules
import React from 'react';

// Images
import logo from 'assets/images/app-logo.png';

// Styles
import styles from './PoweredByPayHero.module.scss';

const PoweredByPayHero = () => {
  return (
    <div className={styles.container}>
      <p>Powered By</p>
      <img src={logo} alt='PayHero' />
    </div>
  );
};

export default PoweredByPayHero;
